export default function formLabel({ colors }) {
  const { text } = colors;

  const formLabel = {
    styleOverrides: {
      root: {
        color: text.main,
      },
    },
  };

  return formLabel;
}
